// src/components/SidebarItem.js
import React from "react";
import { NavLink } from "react-router-dom";
import styles from "./SidebarItem.module.css";

export default function SidebarItem({ label, icon: Icon, path, collapsed, end = false, badge = 0 }) {
  // Check if icon is a string (PNG/image URL) or a React component (SVG)
  const isImageUrl = typeof Icon === 'string';
  const showBadge = badge > 0;

  return (
    <NavLink
      to={`/dashboard/${path}`}
      end={end}
      className={({ isActive }) =>
        `${styles.item} ${isActive ? styles.active : ""}`
      }
    >
      <span className={styles.iconWrap}>
        {isImageUrl ? (
          <img src={Icon} alt={label} className={styles.icon} />
        ) : (
          <Icon className={styles.icon} />
        )}
        {showBadge && collapsed && (
          <span className={`${styles.badge} ${styles.badgeDot}`}>{badge > 99 ? "99+" : badge}</span>
        )}
      </span>
      {!collapsed && <span className={styles.label}>{label}</span>}
      {showBadge && !collapsed && <span className={styles.badge}>{badge > 99 ? "99+" : badge}</span>}
    </NavLink>
  );
}
